<template>
  <triggers-list
    :campaign-id="this.$route.query.id"
    :show-profile="showProfile"
  />
</template>

<script>
import TriggersList from '@/modules/notifications-log/components/TriggersList'
import { campaignTriggerTypes } from '@/modules/campaign-manage/enum/CampaignTriggerTypesEnum'

export default {
  name: 'CampaignExecutionsPage',

  props: {
    campaign: {
      type: Object
    }
  },

  components: {
    TriggersList
  },

  computed: {
    showProfile() {
      return (
        this.campaign &&
        [
          campaignTriggerTypes.TRIGGER_LOCATION,
          campaignTriggerTypes.TRIGGER_EVENT,
          campaignTriggerTypes.TRIGGER_ACCUMULATION
        ].includes(this.campaign.trigger)
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/campaigns/pages/CampaignTriggersPage.vue